import React, { useState, useEffect, useRef } from 'react';
import { animate } from 'animejs';
import supabase from '../../supabase/supabase';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { formatPHP, formatDate } from '../../utils/format';

const { FiX, FiLock, FiAlertTriangle } = FiIcons;
const TABLE_NAME = 'topups_1739880000000';

const DeleteTopupModal = ({ topup, onClose, onSuccess }) => {
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const modalRef = useRef(null);

  useEffect(() => {
    if (modalRef.current) {
      animate(modalRef.current, {
        opacity: [0, 1],
        scale: [0.92, 1],
        duration: 300,
        ease: 'outExpo',
      });
    }
  }, []);

  const handleClose = () => {
    animate(modalRef.current, {
      opacity: [1, 0],
      scale: [1, 0.92],
      duration: 200,
      ease: 'inExpo',
      onComplete: onClose,
    });
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== 'Subic@123') {
      setError('Incorrect password. Access denied.');
      animate(modalRef.current, {
        translateX: [-8, 8, -6, 6, -3, 3, 0],
        duration: 350,
        ease: 'linear',
      });
      return;
    }
    setIsSubmitting(true);
    try {
      const { error: deleteError } = await supabase.from(TABLE_NAME).delete().eq('id', topup.id);
      if (deleteError) throw deleteError;
      onSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div ref={modalRef} className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden" style={{ opacity: 0 }}>
        <div className="p-6 bg-red-50 border-b border-red-100 flex justify-between items-center text-red-600">
          <div className="flex items-center space-x-3">
            <SafeIcon icon={FiAlertTriangle} className="text-xl" />
            <h3 className="text-xl font-bold">Delete Top-up</h3>
          </div>
          <button onClick={handleClose} className="p-2 hover:bg-red-100 rounded-full transition-colors">
            <SafeIcon icon={FiX} />
          </button>
        </div>
        <div className="p-6 space-y-6">
          <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
            <p className="text-xs text-gray-500 uppercase font-bold tracking-wider mb-2">Record to remove:</p>
            <div className="flex justify-between items-center">
              <span className="text-gray-600 text-sm font-medium">{formatDate(topup.date)}</span>
              <span className="font-bold text-red-600 text-lg">{formatPHP(topup.amount)}</span>
            </div>
            {topup.note && <p className="text-xs text-gray-500 mt-2 italic">"{topup.note}"</p>}
          </div>
          <form onSubmit={handleDelete} className="space-y-4">
            {error && <div className="p-3 bg-red-50 text-red-600 rounded-lg text-sm border border-red-100">{error}</div>}
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Admin Password</label>
              <div className="relative">
                <SafeIcon icon={FiLock} className="absolute left-3 top-3 text-gray-400" />
                <input type="password" required autoFocus placeholder="Enter Subic@123"
                  className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-xl focus:ring-red-500 focus:border-red-500"
                  value={password} onChange={(e) => setPassword(e.target.value)} />
              </div>
            </div>
            <div className="flex space-x-3 pt-2">
              <button type="button" onClick={handleClose} className="flex-1 py-3 px-4 bg-gray-100 text-gray-700 font-medium rounded-xl hover:bg-gray-200">Cancel</button>
              <button type="submit" disabled={isSubmitting} className="flex-1 py-3 px-4 bg-red-600 text-white font-bold rounded-xl hover:bg-red-700 disabled:opacity-50">
                {isSubmitting ? 'Deleting...' : 'Confirm Delete'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DeleteTopupModal;
